export default {
    'Mega Menu': 'Mega menú',
    Search: 'Buscar',
    Menu: 'Menú',
    Dashboard: 'Tablero',
    Calendar: 'Calendario',
    Chat: 'Charla',
    Ecommerce: 'Comercio electrónico',
    Products: 'Productos',
    'Product Detail': 'Detalle del producto',
    Orders: 'Pedidos',
    Customers: 'Clientes',
    Cart: 'Carro',
    Checkout: 'Revisa',
    Shops: 'Tiendas',
    'Add Product': 'Añadir Producto',
    Email: 'Correo electrónico',
    Inbox: 'Bandeja de entrada',
    'Read Email': 'Leer el correo electrónico',
    'Kanban Board': 'Kanban Board',
    Layouts: 'Diseños',
    Horizontal: 'Horizontal',
    'Dark Sidebar': 'Barra lateral oscura',
    'Default Sidebar': 'Barra lateral predeterminada',
    'Compact Sidebar': 'Barra lateral compacta',
    'Icon Sidebar': 'Barra lateral de iconos',
    'Boxed Layout': 'Diseño en caja',
    'Fluid Layout': 'Diseño fluido',
    Preloader: 'Precargador',
    'Without Preloader': 'Sin precargador',
    Pages: 'Páginas',
    Authentication: 'Autenticación',
    Login: 'Iniciar sesión',
    Register: 'Registrarse',
    'Recover Password': 'Recuperar contraseña',
    'Lock Screen': 'Bloquear pantalla',
    Utility: 'Utilidad',
    'Starter Page': 'Página de inicio',
    Maintenance: 'Mantenimiento',
    'Coming Soon': 'Próximamente',
    Timeline: 'Cronograma',
    FAQs: 'Preguntas frecuentes',
    Pricing: 'Precios',
    'Error 404': 'error 404',
    'Error 500': 'Error 500',
    Components: 'Componentes',
    'UI Elements': 'Elementos de la IU',
    Alerts: 'Alertas',
    Buttons: 'Botones',
    Cards: 'Tarjetas',
    Carousel: 'Carrusel',
    Dropdowns: 'Listas deplegables',
    Grid: 'Cuadrícula',
    Images: 'Imágenes',
    Lightbox: 'Caja ligera',
    Modals: 'Modalidades',
    'Range Slider': 'Control deslizante de rango',
    'Round Slider': 'Control deslizante redondo',
    'Session Timeout': 'Hora de término de la sesión',
    'Progress Bars': 'Barras de progreso',
    'Sweet Alerts': 'Alertas dulces',
    'Tabs & Accordions': 'Pestañas y acordeones',
    Typography: 'Tipografía',
    Video: 'Vídeo',
    General: 'General',
    Rating: 'Clasificación',
    Notifications: 'Notificaciones',
    Forms: 'Formas',
    Elements: 'Elementos',
    Validation: 'Validación',
    'Advanced Plugins': 'Complementos avanzados',
    Editors: 'Editores',
    'File Upload': 'Subir archivo',
    'X-editable': 'X-editable',
    Wizard: 'Mago',
    Mask: 'Máscara',
    Tables: 'Mesas',
    'Basic Tables': 'Tablas Básicas',
    'Data Tables': 'Tablas de datos',
    'Responsive Table': 'Mesa receptiva',
    'Editable Table': 'Tabla editable',
    Charts: 'Gráficos',
    Apexcharts: 'Apexcharts',
    Chartist: 'Chartista',
    Chartj: 'Chartj',
    'Jquery Knob': 'Perilla Jquery',
    Sparkline: 'Sparkline',
    Icons: 'Íconos',
    'Remix Icons': 'Remix iconos',
    'Material Design': 'Diseño de materiales',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Font awesome 5',
    Maps: 'Mapas',
    'Google Maps': 'mapas de Google',
    'Vector Maps': 'Mapas vectoriales',
    'Multi Level': 'Multi nivel',
    'Level 1.1': 'Nivel 1.1',
    'Level 1.2': 'Nivel 1.2',
    'Level 2.1': 'Nivel 2.1',
    'Level 2.2': 'Nivel 2.2',
    Profile: 'Perfil',
    'My Wallet': 'Mi billetera',
    Settings: 'Configuraciones',
    'View more': 'Ver más',
    'View all': 'Ver todo',
    Logout: 'Cerrar sesión',
    'Your order is placed': 'Su pedido es realizado',
    'If several languages coalesce the grammar': 'Si varios idiomas fusionan la gramática',
    'Your item is shipped': 'Su artículo es enviado',
    '3 min ago': 'Hace 3 minutos',
    'James Lemire': 'James Lemire',
    'It will seem like simplified English.': 'Parecerá un inglés simplificado.',
    '1 hours ago': 'Hace 1 hora',
    'Salena Layfield': 'Salena Layfield',
    'As a skeptical Cambridge friend of mine occidental.': 'Como un escéptico amigo de Cambridge occidental.',
    'View More..': 'Ver más..',
    'UI Components': 'Componentes de la IU',
    Applications: 'Aplicaciones',
    'Extra Pages': 'Páginas extra',
    Github: 'Github',
    Bitbucket: 'Bitbucket',
    Dribble: 'Regatear',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Chimpancé de correo',
    Slack: 'Flojo'
};
